import singaporeFamilyImg from "../../assets/images/image-13.png";
import dubaiTripImg from "../../assets/images/image-14.png";
import clockIcon from "../../assets/images/clock-icon.svg";
import documentIcon from "../../assets/images/document-normal-icon.svg";
import smsIcon from "../../assets/images/sms-edit-icon.png";
import amazonPayIcon from "../../assets/images/amazon-pay-icon.png";
import phonePeIcon from "../../assets/images/phone-pe-icon.png";
import paytmIcon from "../../assets/images/paytm-icon.png";
import clockTimeIcon from "../../assets/images/clock-time-icon.svg";
import documentWordsIcon from "../../assets/images/document-words-icon.svg";
import timeWordsIcon from "../../assets/images/time-words-icon.svg";
import monetizeIcon from "../../assets/images/monetize-icon.png";
import travelPlansIcon from "../../assets/images/travel-plans-icon.png";
import brandIcon from "../../assets/images/brand-icon.png";
import { routes } from "../../routes";
import CryptoJS from "crypto-js";

export const footerMenus = [
  {
    title: "Company",
    items: [
      {
        menu: "About",
        link: routes.ABOUT,
      },
      {
        menu: "How It Works",
        link: routes.HOW_IT_WORKS,
      }
    ]
  },
  {
    title: "Contact",
    items: [
      {
        menu: "FAQ",
        link: routes.FAQS,
      },
      {
        menu: "Reach Us",
        link: routes.REACH_US,
      }
    ]
  },
  {
    title: "More",
    items: [
      {
        menu: "Privacy Policy",
        link: routes.PRIVACY_POLICY,
      },
      {
        menu: "Terms of Use",
        link: routes.TERMS_USE,
      },
      {
        menu: "Cancellation Policy",
        link: routes.CANCELLATION_POLICY,
      }
    ]
  }
]

export const verifiedAdvisor = [
  {
    id: 1,
    title: "Singapore Family Trip",
    image: singaporeFamilyImg,
    description:
      "That sounds wonderful! I'd love to hear more about your experience.",
    rating: 4,
    verified: true,
    price: 300,
  },
  {
    id: 2,
    title: "Dubai Trip",
    image: dubaiTripImg,
    description:
      "That sounds wonderful! I'd love to hear more about your experience.",
    rating: 4,
    verified: true,
    price: 300,
  },
];

export const advisorsTabs = [
  {
    tab: "Call",
    icon: clockIcon,
    value: 1,
  },
  {
    tab: "Itinerary",
    icon: documentIcon,
    value: 2,
  },
  {
    tab: "Call + Itinerary",
    value: 3,
  },
];

export const timeGroups = [
  {
    title: "30 mins",
  },
  {
    title: "45 mins",
  },
  {
    title: "1 Hour",
  },
];

export const socialButtons = [
  {
    title: "Sign up with email",
    icon: smsIcon,
  },
];

export const paymentOptions = [
  {
    title: "Amazon Pay",
    icon: amazonPayIcon,
  },
  {
    title: "PhonePe",
    icon: phonePeIcon,
  },
  {
    title: "PayTM",
    icon: paytmIcon,
  },
];

export const advisorsOptions = [
  {
    title: "Call",
    icon: clockTimeIcon,
    value: 1,
  },
  {
    title: "Itinerary",
    icon: documentWordsIcon,
    value: 2,
  },
  {
    title: "Call + Itinerary",
    icon: timeWordsIcon,
    value: 3,
  },
];

export const beAdvisorExperience = [
  {
    icon: monetizeIcon,
    title: "Monetize Your Experience",
    content:
      "Turn your travel experiences into earnings by offering personalized advice to those looking for guidance.",
  },
  {
    icon: travelPlansIcon,
    title: "Share Your Travel Plans or Experiences",
    content:
      "Whether it’s selling a detailed itinerary, sharing a unique experience, or offering time for a personal consultation, Bruvvi allows you to choose how you want to engage with users.",
    className: "lg:col-span-3 lg:border-x lg:px-[30px]",
  },
  {
    icon: brandIcon,
    title: "Build Your Brand",
    content:
      "Gain visibility by sharing your unique experiences, stories, and insights with a community eager for authentic travel advice.",
  },
];

export const beAdvisorSteps = [
  {
    title: "Step 1",
    subtitle: "Download the Bruvvi App",
    description: "Available on Google Play and App Store.",
  },
  {
    title: "Step 2",
    subtitle: "Sign Up as an Advisor",
    description:
      "Create your advisor profile to showcase your expertise, experience, and achievements, building trust with potential clients.",
  },
  {
    title: "Step 3",
    subtitle: "Create Your Advice",
    description:
      "Share your unique insights by creating travel itineraries or experiences. Set your pricing and availability for consultations.",
  },
  {
    title: "Step 4",
    subtitle: "Travel Experience Verification",
    description:
      "Verify your travel experience by submitting travel-related documents (boarding passes, hotel receipts, etc.).",
  },
  {
    title: "Step 5",
    subtitle: "Start Earning",
    description:
      "Begin offering advice to users and build your reputation as a trusted travel advisor!",
    className: "hidden",
  },
];

export const whatAreYouOptions = [
  {
    label: "🌍 Content Creator (YouTube, Instagram, Blog, etc.)",
    value: "content_creator",
  },
  {
    label: "✈️ Seasoned Traveler (Been to multiple destinations & love sharing insights)",
    value: "seasoned_traveler",
  },
  {
    label: "🗺️ Travel Guide / Tour Operator",
    value: "travel_guide",
  },
  {
    label: "🏕️ Adventure Enthusiast (Trekking, Diving, Biking, etc.)",
    value: "adventure_enthusiast",
  },
  {
    label: "👨‍👩‍👧 Family Travel Expert (Specialist in kid-friendly or multi-gen trips)",
    value: "family_travel_expert",
  },
  {
    label: "🏳️‍🌈 LGBTQ+ Travel Specialist (Safe & inclusive travel advice)",
    value: "lgbtq_travel_specialist",
  },
  {
    label: "🏨 Luxury Travel & Hospitality Expert",
    value: "luxury_travel_expert",
  },
  {
    label: "🐾 Pet-Friendly Travel Enthusiast",
    value: "pet_friendly_traveler",
  },
  {
    label: "🚆 Budget Traveler / Backpacker",
    value: "budget_traveler",
  },
  {
    label: "📍 Local Destination Expert (Deep knowledge of a specific place)",
    value: "local_destination_expert",
  },
  {
    label: "🎒 Digital Nomad / Remote Work Traveler",
    value: "digital_nomad",
  },
  {
    label: "🤝 Other",
    value: "other",
  },
];

export const profileTabs = [
  {
    tab: "Destination",
    value: "Destination",
  },
  {
    tab: "Experience",
    value: "Experience",
  },
];

export const timeIssues = [
  {
    id: 1,
    label: "Advisor Was Distracted",
    description:
      "The advisor seemed distracted or was multitasking during the call.",
  },
  {
    id: 2,
    label: "Call Was Cut Short",
    description:
      "The video call ended prematurely without completing the discussion.",
  },
  {
    id: 3,
    label: "Inaccurate Information Provided",
    description: "The information or advice given was incorrect or misleading.",
  },
  {
    id: 4,
    label: "Poor Audio/Video Quality",
    description:
      "The advisor had technical issues such as bad sound or unclear video.",
  },
  {
    id: 5,
    label: "Advisor Was Unprofessional",
    description:
      "The advisor was rude, disrespectful, or unprofessional during the call.",
  },
  {
    id: 6,
    label: "Call Was Interrupted Repeatedly",
    description:
      "The video call was frequently interrupted by the advisor for personal reasons or technical issues.",
  },
  {
    id: 7,
    label: "Advisor Gave Generic Advice",
    description:
      "The advice provided was too generic or not personalized to the user's needs.",
  },
  {
    id: 8,
    label: "Misleading Itinerary Details",
    description:
      "The itinerary discussed during the call was not as advertised or lacked key details.",
  },
  {
    id: 9,
    label: "Advisor Was Unprepared",
    description:
      "The advisor lacked the necessary information or seemed unprepared for the discussion.",
  },
  {
    id: 10,
    label: "Advisor Was Late",
    description:
      "The advisor joined the call late, reducing the allotted time.",
  },
];

export const wordsIssues = [
  {
    id: 1,
    label: "Inaccurate Itinerary Details",
    description:
      "The information in the itinerary was incorrect (e.g., wrong locations, incorrect times).",
  },
  {
    id: 2,
    label: "Itinerary Did Not Match Description",
    description:
      "The purchased itinerary differed significantly from what was advertised or promised.",
  },
  {
    id: 3,
    label: "Outdated Information",
    description:
      "The itinerary contained outdated information (e.g., closed attractions, restaurants no longer in business).",
  },
  {
    id: 4,
    label: "Poorly Planned Itinerary",
    description:
      "The itinerary was unrealistic or poorly structured (e.g., too much travel between locations, insufficient time for activities).",
  },
  {
    id: 5,
    label: "Generic Itinerary",
    description:
      "The itinerary was too generic and didn’t offer personalized or unique insights as promised.",
  },
  {
    id: 6,
    label: "Overly Complex or Confusing",
    description:
      "The itinerary was hard to understand, with unclear directions or disorganized information.",
  },
  {
    id: 7,
    label: "Itinerary Lacked Specific Activities or Locations",
    description:
      "The itinerary didn’t include key activities or places that were advertised.",
  },
  {
    id: 8,
    label: "Advisor Provided Incomplete Itinerary",
    description:
      "Parts of the itinerary were missing, such as full details on transportation or accommodations.",
  },
  {
    id: 9,
    label: "Poor Recommendations",
    description:
      "The recommendations (hotels, restaurants, activities) were of poor quality or unsuitable.",
  },
  {
    id: 10,
    label: "Misleading Photos or Descriptions",
    description:
      "The photos or descriptions used to sell the itinerary were misleading compared to the actual experience.",
  },
];

export const timeAndWordsIssues = [
  {
    title: "Call",
    icon: clockIcon,
    issues: timeIssues,
    category: "time"
  },
  {
    title: "Itinerary",
    icon: documentIcon,
    issues: wordsIssues,
    category: "word"
  },
];

export const advisorTopicDetailsTab = [
  {
    tab: "Summary",
    value: 1,
  },
  {
    tab: "Introduction",
    value: 2,
  },
]

export const submenus = [
  {
    title: "Settings",
    path: routes.SETTINGS,
  },
  {
    title: "Be an Advisor",
    path: routes.BE_AN_ADVISOR,
  },
  {
    title: "Reach Us",
    path: routes.REACH_US,
  },
  {
    title: "Change Password",
    path: routes.CHANGE_PASSWORD,
  },]

export const currencySymbolMap = {
  USD: "USD",
  INR: "INR",
  EUR: "EUR",
};

export const getMinPriceWithCurrency = (pricing) => {
  if (pricing) {
    const minPrice = Math.min(
      ...Object.entries(pricing)
        .filter(([key, val]) => key.includes("price") && typeof val === "number")
        .map(([_, val]) => val)
    );

    const symbol = currencySymbolMap[pricing.currency] + " " || pricing.currency;
    return `${symbol}${minPrice}`;
  } else {
    return "--";
  }

};

export const getMinPrice = (pricing, requireSymbol = true) => {

  if (!pricing) return "--";

  const prices = [];

  const groups = [
    { enabled: "good_time_enabled", prefix: "good_time_" },
    { enabled: "more_time_enabled", prefix: "more_time_" },
    { enabled: "most_time_enabled", prefix: "most_time_" },
    { enabled: "good_chat_time_enabled", prefix: "good_chat_" },
    { enabled: "more_chat_time_enabled", prefix: "more_chat_" },
    { enabled: "most_chat_time_enabled", prefix: "most_chat_" },
    { enabled: "word_enabled", prefix: "word_" },
  ];

  groups.forEach(({ enabled, prefix }) => {
    if (pricing[enabled]) {
      Object.entries(pricing).forEach(([key, value]) => {
        if (
          key.startsWith(prefix) &&
          key.includes("price") &&
          typeof value === "number"
        ) {
          prices.push(value);
        }
      });
    }
  });
  // Find the smallest value > 0
  const validPrices = prices
    .filter((price) => price > 0)
    .sort((a, b) => a - b);

  if (!validPrices.length) return "--";

  const minPrice = validPrices[0];

  const symbol = `${currencySymbolMap[pricing.currency] || pricing.currency} `;

  if (requireSymbol === false) {
    return `${minPrice}`;
  } else {
    return `${symbol} ${minPrice}`;
  }

};

export const encryptId = (id) => {
  const secretKey = process.env.REACT_APP_SHARE_SECRET || "a7f3k9m2x8q1w5e4r6t0y2u8i3o7p1as";
  const encrypted = CryptoJS.AES.encrypt(id, secretKey).toString();
  // Make it URL-safe (remove +, /, =)
  return encrypted
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=/g, "~");
};

export const decryptId = (encryptedId) => {
  if (!encryptedId) return "";
  try {
    const secretKey = process.env.REACT_APP_SHARE_SECRET || "a7f3k9m2x8q1w5e4r6t0y2u8i3o7p1as";
    const encrypted = encryptedId
      .replace(/-/g, "+")
      .replace(/_/g, "/")
      .replace(/~/g, "=");
    const bytes = CryptoJS.AES.decrypt(encrypted, secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Error decrypting ID:", error);
    return "";
  }
};

export const encryptPath = (path, secret) => {
  const secretKey = secret || process.env.REACT_APP_SHARE_SECRET || "a7f3k9m2x8q1w5e4r6t0y2u8i3o7p1as";
  const encrypted = CryptoJS.AES.encrypt(path, secretKey).toString();
  return encrypted
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=/g, "~");
};